import React from 'react';
import Styled from 'styled';
import ImageView, { Props as ImageProps } from 'lib/images/image-view';
import defaultStyles from './image.scss';
import { ImageFragment } from './image.graphql';

export interface Props extends ImageFragment {
    index: number;
    onlyChild: boolean;
    imgRef: (ref: HTMLImageElement | null, props: Props) => void;
    onClick: (event: React.SyntheticEvent<HTMLButtonElement>, props: Props) => void;
    styles: typeof defaultStyles;
}

const StyledImage = (props: Omit<ImageProps, 'styles'>) => (
    <ImageView style={{ image: defaultStyles.image }} {...props} />
);

class Image extends React.PureComponent<Props> {
    onClick = (event: React.SyntheticEvent<HTMLButtonElement>) => {
        this.props.onClick(event, this.props);
    };

    onRef = (ref: HTMLImageElement | null) => {
        this.props.imgRef(ref, this.props);
    };

    render() {
        const { styles, onlyChild, id, alt } = this.props;

        const classNames = [styles.image];
        const { isPortrait, src, srcset, height, width } = this.props.photoFile!;

        if (isPortrait) {
            classNames.push(styles.portrait);
        }

        let ImageComponent = ImageView;
        if (onlyChild) {
            ImageComponent = StyledImage as any;
        }

        return (
            <button className={styles.imageWrapper} onClick={this.onClick}>
                <ImageComponent
                    key={id}
                    forwardedRef={this.onRef}
                    aspectFill={true}
                    aspectRatio={(onlyChild && height && width && height / width) || undefined}
                    srcSet={srcset!}
                    sizes={{
                        xs: isPortrait ? 340 : 384,
                        md: isPortrait ? 480 : 640,
                    }}
                    src={src}
                    alt={alt}
                    linkify={false}
                />
            </button>
        );
    }
}

export default Styled(defaultStyles)(Image);
